import { Modal } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import React from 'react'

import styled from 'styled-components'
import Confirmation from './icons/Confirmation'
import BeforeConfirmation from './icons/BeforeConfirmation'

export const UploadMsgFlex = styled(Flex)`
  height: 100%;
`

export const FlexWrapRole = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
`
export const ShortlistDiv = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: center;
  color: #010e30;
  width: 451px;
  height: 28px;
  margin-top: 15px;
  margin-bottom: 15px;
`

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    align-content: center;
  }
  .ant-modal-body {
    padding: 45px 10px 45px 10px;
  }
  .ant-modal-mask {
    backdrop-filter: blur(10px);
  }
`

const Description = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  display: flex;
  gap: 5px;
  align-items: baseline;
  justify-content: center;
  margin-top: ${props => (props.margin ? props.margin : '10px')};
`

const Title = styled.p`
  font-family: Plus Jakarta Sans;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin: 10px 30px;
  span {
    font-weight: 700;
  }
`
const Title1 = styled.p`
  font-family: Plus Jakarta Sans;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin: 10px 30px;
  color: #010E30;
  span {
    font-weight: 700;
    color: #3249D7;
  }
`
export const GetTPOContent = styled.p`
font-size: 14px;
font-weight: 500;
line-height: 20px;
color:#4D566E;
span{
font-weight: 700;
}
`
const ConfirmationModal = ({
  open,
  onApplyClick,
  onCloseClick,
  description,
  description1,
  title,
  rejectText = "No",
  applyText = "Yes",
  confirm = true,
  dynamicContent = false,
  tpoApproval = false,
  message = []
}) => {
  return (
    <CustomModal
      open={open}
      centered
      footer={null} // Hide the default footer
      maskClosable={false} // Prevent closing the modal when clicking outside
      closable={false} // Hide the close button
      width={836}
      height={434}
    >
      <Flex column>
        <FlexWrapRole center>
         {confirm ? <Confirmation /> : <BeforeConfirmation /> }
        </FlexWrapRole>
        <Description >
         
         {dynamicContent ? <Title1 dangerouslySetInnerHTML={{
            __html: description,
          }} /> : <Title>  {description} {title && <span>{title} ?</span>}</Title> }

         
        </Description>
        {tpoApproval && description1 &&  
        <Description margin={'0px'}> 
     <Title1 dangerouslySetInnerHTML={{
            __html: description1,
          }} />
        </Description>   }

        {tpoApproval && message?.length > 0 &&  
        <Description > 
   <GetTPOContent  dangerouslySetInnerHTML={{
            __html: message,
          }}/> 
        </Description>   }
        <FlexWrapRole gap="20px" center>
          <Button.Secondary
            text={rejectText}
            width="64px"
            height="38px"
            onClick={() => {
              onCloseClick()
            }}
          />
          <Button.Primary
            text={applyText}
            width="auto"
            height="38px"
            onClick={() => {
              onApplyClick()
            }}
          />
        </FlexWrapRole>
      </Flex>
    </CustomModal>
  )
}

export default ConfirmationModal
